module.exports = __webpack_public_path__ + "static/media/importICloud4.dd3d5b1c.png";